module.exports = __webpack_public_path__ + "img/MAID.a0c06a5b.svg";